var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', _vm._b({}, 'v-tab-item', _vm.BANK_VERIFICATION_FORM_TABS.SUCCESS, false), [_c('div', {
    staticClass: "txt txt--xs txt--dark font-weight-medium text-center py-20px py-md-0"
  }, [_vm._v(" 계좌인증이 완료되었습니다."), _c('br'), _vm._v(" 인증된 계좌로 보너스 출금이 가능합니다. ")]), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": _vm.isOnlyVerification ? 12 : 6
    }
  }, [_c('v-btn', {
    staticClass: "v-size--xx-large",
    attrs: {
      "block": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("확인")])], 1), !_vm.isOnlyVerification ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    staticClass: "v-size--xx-large",
    attrs: {
      "block": "",
      "color": "primary",
      "to": "/promoter/bonuses-withdraw"
    }
  }, [_vm._v("출금하러 가기")])], 1) : _vm._e()], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }